import { useEffect, useState } from "react";
import {  ISendMessage, IUser, RootState } from "../../redux/type";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { SendMessageAction, showAllUsers } from "../../redux/createMessage/slice";
import Button from "../UI/Button";
import SendEmailModal from "../modals/SendEmailModal";
import { Console } from "console";

const useAppSelector: TypedUseSelectorHook <RootState> = useSelector 

const usersToShowInLeaderboard = 20
export default function LeaderboardPage() {
   const [showAlltimeLeaderbaord, setShowAlltimeLeaderbaord] = useState(true)
   const [modalOpen, setModalOpen] = useState(false);
  const [selectedUsersEmail, setSelectedUsersEmail] = useState<string[]>([])

    const dispatch  = useDispatch()
    const usersPerPage = 10
    const {users, loading, error, currentPage} = useAppSelector((state) => state.sendMessage);
    useEffect(()=>{
      dispatch(showAllUsers())
      dispatch(SendMessageAction.onClickCurrentPage(1))
    }, [])

    //this will reset the selected users, if admin changes the leaderboard view
    useEffect(() => {
      setSelectedUsersEmail([])
    }, [showAlltimeLeaderbaord]);

    if(loading){
        return (<h2>Loading Data...</h2>)
    }
    if (error) {
      return <h2>Error: {error}</h2>;
    }

    const sortedUsersInAlltimeLeaderboard = [...users].sort((a, b) => b.High_Score_In_AllTime - a.High_Score_In_AllTime).slice(0, usersToShowInLeaderboard);
    const sortedUsersInSingletimeLeaderboard = [...users].sort((a, b) => b.High_Score_In_Month - a.High_Score_In_Month).slice(0, usersToShowInLeaderboard);

    const totalPages = Math.ceil(sortedUsersInAlltimeLeaderboard.length/usersPerPage);
    const indexOfLastPage = currentPage*usersPerPage;
    const indexOfFirstPage = indexOfLastPage - usersPerPage;
    const VisibleUsersInAlltimeLeaderboard = sortedUsersInAlltimeLeaderboard.slice(indexOfFirstPage,indexOfLastPage)
    const VisibleUsersInSingletimeLeaderboard = sortedUsersInSingletimeLeaderboard.slice(indexOfFirstPage,indexOfLastPage)

    const navigatePrev =()=>{
        if(currentPage!==1){
          dispatch(SendMessageAction.onNavigatePrev())
        }
    }
    const navigateNext =()=>{
      if(currentPage!==totalPages){
        dispatch(SendMessageAction.onNavigateNext())
      }
    }
    const handleCurrentPage =(index : any)=>{
      dispatch(SendMessageAction.onClickCurrentPage(index))
    }

    

    //pagination button
    const renderButtons = () => {
      const buttons = [];
  
      const startPage = Math.max(1, currentPage - 1);  //current page is 1

      const endPage = Math.min(startPage + 2, totalPages);
   
      //for first button
      if ((startPage > 1) && (currentPage>3)) {
        buttons.push(
          <button
            key={1}
            className={`btn paginationButton ${1 === currentPage ? "currentPageButton" : ""}`}
            onClick={() => handleCurrentPage(1)}
          >
            {1}
          </button>
        );
        buttons.push(
          <span key="dots-first" className="dots">
            . . .
          </span>
        );
      }

      
      for (let index = startPage; index <= endPage; index++) {
        buttons.push(
          <button
            key={index}
            className={` btn paginationButton ${index === currentPage ? "currentPageButton" : ""}`}
            onClick={() => handleCurrentPage(index)}
          >
            {index}
          </button>          
        );
      }  

      //for last button
      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          buttons.push(
            <span key="dots" className="dots">
             . . . 
            </span>
          );
        }
    
        buttons.push(
          <button
            key={totalPages}
            className={`btn paginationButton ${totalPages === currentPage ? "currentPageButton" : ""}`}
            onClick={() => handleCurrentPage(totalPages)}
          >
            {totalPages}
          </button>
        );
      }

      return buttons;
    };
    
    const handleCheckboxChangeOfUser = (email: string) => {
      setSelectedUsersEmail((prev) =>
        prev.includes(email) ? prev.filter((e) => e !== email) : [...prev, email]
      );
      console.log("multiple users in handleCheckboxChangeOfUser", selectedUsersEmail)
    };

    //for sending email to single user
    const handleOpenModal=(usersEmail : any)=>{
        setSelectedUsersEmail(() => [usersEmail]);
        setModalOpen(true)
    }

    //for sending email to multiple selected user
    const selectCheckedUsersToSendEmail = () =>{
      setModalOpen(true)
      console.log("multiple users in selectCheckedUsersToSendEmail", selectedUsersEmail)
    }

    //for sending email to all user
    const selectAllUsersToSendEmailInSingleTimeLeaderboard = () =>{
      const allUsersEmails = sortedUsersInSingletimeLeaderboard.map((user: IUser) => user.Email);
      setSelectedUsersEmail(allUsersEmails);
      setModalOpen(true)

      console.log("All users' emails in selectAllUsersToSendEmailInSingleTimeLeaderboard:", allUsersEmails);
      console.log("multiple users in selectAllUsersToSendEmailInSingleTimeLeaderboard", selectedUsersEmail)
    }

    const selectAllUsersToSendEmailInSAllTimeLeaderboard = () =>{
      const allUsersEmails = sortedUsersInAlltimeLeaderboard.map((user: IUser) => user.Email);
      setSelectedUsersEmail(allUsersEmails);
      setModalOpen(true)

      console.log("All users' emails in selectAllUsersToSendEmailInSAllTimeLeaderboard:", allUsersEmails);
      console.log("multiple users in selectAllUsersToSendEmailInSAllTimeLeaderboard", selectedUsersEmail)
    }
    
  return (showAlltimeLeaderbaord?
    <main>
      <div className="container-fluid px-4">
        
        <div className="d-flex">
          <h1>All Time Leaderboard</h1>
          <Button text= "View Single Run Leaderboard" onClick={()=>{setShowAlltimeLeaderbaord(false)
                                                          dispatch(SendMessageAction.onClickCurrentPage(1))}} className={`btn emailButtonForMultipleUsers btn-secondary btn-sm`} />

          {selectedUsersEmail.length >0 ?<Button text= "Send Email to selected users" 
                      onClick={() => selectCheckedUsersToSendEmail()}
                      className={`btn emailButtonForMultipleUsers btn-warning btn-sm`} /> : null}
          <Button text= "Send Email to all users" onClick={() => selectAllUsersToSendEmailInSAllTimeLeaderboard()} className={`btn emailButtonForMultipleUsers ms-auto btn-info btn-sm`} />
        </div>
        <div className="mb-4">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Username</th>
                  <th>Email ID</th>
                  <th>Score</th>
                  <th>Select user</th>
                </tr>
              </thead>
              <tbody>
         
              {VisibleUsersInAlltimeLeaderboard.map((user: IUser, index) => (
                  <tr key={user.Id}>
                    <td>{index + 1 + indexOfFirstPage}</td>
                    <td>{user.UserName.trim()==="" ? "No Username" : user.UserName }</td>
                    <td>{user.Email}
                      {index+1 + indexOfFirstPage<=3 ?  <Button text= "Send Email" 
                      onClick={() => handleOpenModal(user.Email)}
                      className={`btn buttonEmail btn-primary btn-sm`} /> : null}
                    </td>

                    <td>{user.High_Score_In_AllTime}</td>
                    <td>
                    <input
                        type="checkbox"
                        checked={selectedUsersEmail.includes(user.Email)}
                        onChange={() => handleCheckboxChangeOfUser(user.Email)}
                        />
                    </td>

                  </tr>
                ))}
                {modalOpen &&  <SendEmailModal usersEmail = {selectedUsersEmail} setSelectedUsersEmail= {setSelectedUsersEmail} setOpenModal={setModalOpen} />}
                
              </tbody>
            </table>
          </div>
          <div>
            <span className="btn paginationButton" onClick={()=>navigatePrev()}>Prev</span> 
            <span>{renderButtons()}</span> 
            <span className="btn paginationButton" onClick={()=>navigateNext()}>Next</span> 
            <p style={{padding: "0.375rem 0.75rem"}}>Current Page is {currentPage} of {totalPages}</p>     
    
        </div>
        </div>
        
      </div>
      
    </main>
    :   
    <main>
      <div className="container-fluid px-4">
        <div className="d-flex">
            <h1>Single Run Leaderboard</h1>
            <Button text= "View All Time Leaderboard" onClick={()=>{setShowAlltimeLeaderbaord(true)
                                                            dispatch(SendMessageAction.onClickCurrentPage(1))}} className={`btn emailButtonForMultipleUsers btn-secondary btn-sm`} />

          {selectedUsersEmail.length >0 ?<Button text= "Send Email to selected users" 
                      onClick={() => selectCheckedUsersToSendEmail()}
                      className={`btn emailButtonForMultipleUsers btn-warning btn-sm`} /> : null}
          <Button text= "Send Email to all users" onClick={() => selectAllUsersToSendEmailInSingleTimeLeaderboard()} className={`btn emailButtonForMultipleUsers ms-auto btn-info btn-sm`} />
        
        </div>   
        <div className="mb-4">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Username</th>
                  <th>Email ID</th>
                  <th>Score</th>
                  <th>Select user</th>
                </tr>
              </thead>
              <tbody>
         
              {VisibleUsersInSingletimeLeaderboard.map((user: IUser, index) => (
                  <tr key={user.Id}>
                    <td>{index + 1 + indexOfFirstPage}</td>
                    <td>{user.UserName.trim()==="" ? "No Username" : user.UserName }</td>
                    <td>{user.Email}
                      {index+1 + indexOfFirstPage<=3 ?  <Button text= "Send Email" 
                      onClick={() => handleOpenModal(user.Email)}
                      className={`btn buttonEmail btn-primary btn-sm`} /> : null}
                    </td>

                    <td>{user.High_Score_In_Month}</td>
                    <td>
                    <input
                        type="checkbox"
                        checked={selectedUsersEmail.includes(user.Email)}
                        onChange={() => handleCheckboxChangeOfUser(user.Email)}
                        />
                    </td>

                  </tr>
                ))}
                {modalOpen &&  <SendEmailModal usersEmail = {selectedUsersEmail} setSelectedUsersEmail= {setSelectedUsersEmail}  setOpenModal={setModalOpen} />}
                
              </tbody>
            </table>
          </div>
          <div>
            <span className="btn paginationButton" onClick={()=>navigatePrev()}>Prev</span> 
            <span>{renderButtons()}</span> 
            <span className="btn paginationButton" onClick={()=>navigateNext()}>Next</span> 
            <p style={{padding: "0.375rem 0.75rem"}}>Current Page is {currentPage} of {totalPages}</p>     
    
        </div>
        </div> 
      </div>
    </main>
  );

}
